export default {
  namespaced: true,
  state: {
    selectedRole: null,
    allRoles: [],
    allAssignedRoles: []
  },
  mutations: {
    setSelectedRole(state, roleId) {
      state.selectedRole = roleId;
    },
    setAllRoles(state, roles) {
      state.allRoles = roles;
    },
    setAllAssignedRoles(state, assignedRoles) {
      state.allAssignedRoles = assignedRoles;
    }
  },
  getters: {
    getUserRole: (state) => state.selectedRole,
    getAllRoles: (state) => state.allRoles,
    getAllAssignedRoles: (state) => state.allAssignedRoles
  }
};
